// frontend/src/components/admin/DashboardLoader.tsx
// ───────────────────────────────────────────────────────────────────
// Écran de chargement plein écran SOMBRE pour le dashboard / admin resto
// (TASK-037). Évite le flash blanc : sans lui, le fallback Suspense + les
// états de chargement rendent un spinner sur le `body` clair (bg-slate-50)
// avant que la page sombre ne monte.
//
// ⚠️ RÉSERVÉ AUX ÉCRANS SOMBRES (tenant / admin resto). Il peint un bloc
// `bg-stone-950` sur toute la hauteur : utilisé comme fallback dans le shell
// CLAIR du Super Admin, il produit un rectangle noir dans la zone de contenu au
// premier chargement (constaté en smoke prod 2026-08-12). Côté Super Admin,
// utiliser `<LoadingState>` (SAUX-03) — un garde-fou de test le vérifie
// (`frontend/tests/unit/router-loaders.test.ts`).
// ───────────────────────────────────────────────────────────────────

import type { JSX } from 'react';

export function DashboardLoader(): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen w-full items-center justify-center bg-stone-950"
      style={{ fontFamily: "'Inter', system-ui, sans-serif" }}
    >
      <span
        aria-hidden="true"
        className="h-8 w-8 animate-spin rounded-full border-2 border-stone-700 border-t-amber-500"
      />
      <span className="sr-only">Chargement…</span>
    </div>
  );
}
